/**
 * Conditionally choose whether to return the questions with or without subQuestions.
 *
 * This is controlled using { includesSubQuestions: true }
 * @see getIncludesSubQuestions
 */

import { createSelector } from 'reselect';

import getQuestions from './getQuestions';
import getIncludesSubQuestions from './getIncludesSubQuestions';
import getQuestionsAndSubQuestions from './getQuestionsAndSubQuestionsSelector';

export default createSelector(
  [getQuestionsAndSubQuestions, getQuestions, getIncludesSubQuestions],
  (questionsAndSubQuestions, questions, includesSubQuestions) =>
    includesSubQuestions ? questionsAndSubQuestions : questions,
);
